module.exports = __webpack_public_path__ + "img/fun.fc77db35.jpg";